import isNameValid from "./is-name-valid-aggregator";

export default function isManageSubUserNameValid(data) {
  return isNameValid(data.firstName) && isNameValid(data.lastName);
}
